// extracted by mini-css-extract-plugin
var _1 = "QagYI";
export { _1 as "base" }
